<template>
  <div id="app">
    <router-view name="header" />
    <div class="wrapper">
      <router-view />
    </div>
    <router-view name="footer" />
  </div>
</template>
<script>
import { Validator } from "vee-validate";
export default {
  name: "app",
  created() {
    Validator.extend("selectRequired", {
      getMessage: field => "The " + field + " field is required.",
      validate: value => value.name !== " - Please select - "
    });
  }
};
</script>

<style>
.help-block {
  color: #FF3636;
}
</style>
